import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Header from "../../components/Common/Header/Header";
import Footer from '../../components/Common/Footer/Footer';
import IntroSectionAdminCloud from '../../components/AdminCloud/IntroSectionAdminCloud/IntroSectionAdminCloud';
import IntroSectionAdminCloud2 from '../../components/AdminCloud/IntroSectionAdminCloud/IntroSectionAdminCloud2';
import IntroSectionAdminCloud3 from '../../components/AdminCloud/IntroSectionAdminCloud/IntroSectionAdminCloud3';
import ServicesCardsPrivateCloud from '../../components/PrivateCloud/ServicesCardsPrivateCloud/ServicesCardsPrivateCloud';
import ExpertiseSectionAdminCloud from '../../components/AdminCloud/ExpertiseSectionAdminCloud/ExpertiseSectionAdminCloud'
import PricingPrivateCloud from '../../components/PrivateCloud/PricingPrivateCloud/PricingPrivateCloud';
import Navbar from '../../components/Common/Navbar/Navbar'
import Newsletter from '../../components/Common/Newsletter/Newsletter';
import ServiceList from '../../components/AdminCloud/ServicesSliderAdminCloud/ServicesSliderAdminCloud';
import ExpertiseSection from '../../components/AdminCloud/ExpertiseSectionAdminCloud/ExpertiseSectionAdminCloud';
import IntroSectionBottom from '../../components/Common/IntroSectionBottom/IntroSectionBottom';
import introSectionData2 from '../../components/Common/IntroSectionBottom/introSectionData2';
import useSectionRefs from '../../hooks/useSectionRefs';
import BenefitsAdminCloud from '../../components/AdminCloud/ServicesSliderAdminCloud/BenefitsAdminCloud';
import { contactLinkData } from '../../data/contactLinkData';
import ContactLinkSection from '../../components/Common/ContactLinkSection/ContactLinkSection';
import TimelineAdminCloud from '../../components/AdminCloud/Timeline/TimelineAdminCloud';
import { GridPatternCard, GridPatternCardBody } from '../../components/ui/card-with-ellipsis-pattern';
import PricingSectionAzureMigrationManaged from '../../components/ui/pricing-section-azure-migration-managed';

const AdminCloud: React.FC = () => {
    const { t } = useTranslation();
    const sectionRefs = useSectionRefs();
    const [isContactModalOpen, setIsContactModalOpen] = useState(false);
  
    const handleOpenContactModal = () => {
      setIsContactModalOpen(true);
    };
  
    const handleCloseContactModal = () => {
      setIsContactModalOpen(false);
    };

  return (
    <div>
      <div>
      <section id="header" className="section dark" ref={sectionRefs.header}>
        <div>
          <Navbar 
            sectionRefs={sectionRefs}
            openContactModal={handleOpenContactModal}
            closeContactModal={handleCloseContactModal}
          />
          <Header 
            title={t('adminCloud.header.title', 'Services Azure Managés')} 
            subtitle={t('adminCloud.header.subtitle', 'Déléguez l\'administration de vos systèmes cloud.')} 
          />
        </div>
      </section>
      <section id="start" className="section light" ref={sectionRefs.start}>
        <IntroSectionAdminCloud />
      </section>

            <section id="commitment" className="section light commitment-section" ref={sectionRefs.commitment}>
        <IntroSectionAdminCloud3 />
      </section>

      <section id="cloud" className="section dark" ref={sectionRefs.cloud}>
        <IntroSectionAdminCloud2 />
      </section>

      <div className="gradient-bg">
      <section id="start2" className="section light" ref={sectionRefs.start2}>
        <PricingSectionAzureMigrationManaged openContactModal={handleOpenContactModal} />
      </section>
          <div className="gradient-bg">
            <section
              id="expertise"
              className="section dark"
              ref={sectionRefs.expertise}
            >
      <TimelineAdminCloud />
      <GridPatternCard>
      <GridPatternCardBody>
        <div className="tw-h-[5em]">
        </div>
      </GridPatternCardBody>
    </GridPatternCard>
        </section>
      </div>
      <section id="newsletter" className="section dark" ref={sectionRefs.newsletter}>
      <ContactLinkSection pageKey="adminCloud" />
        <Footer />
      </section>
    </div>
    </div> 
    </div>
  );
};

export default AdminCloud;
